export default __webpack_public_path__ + "images/0x7b35ce522cb72e4077baeb96cb923a5529764a00.png";